import Button from "@pathwright/ui/src/components/button/Button"
import DropdownItem from "@pathwright/ui/src/components/dropdown/DropdownItem"
import DropdownMenu from "@pathwright/ui/src/components/dropdown/DropdownMenu"
import DropdownTrigger from "@pathwright/ui/src/components/dropdown/DropdownTrigger"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import classnames from "classnames"
import PropTypes from "prop-types"
import styled from "styled-components"

const StyledRow = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
`

const CommunitAreaDropdown = ({
  control: activeControl,
  controls,
  onChange,
  getControlLabel,
  alignment,
  inverted,
  translator,
  ...buttonProps
}) => (
  <DropdownTrigger
    alignment={alignment}
    renderDropdown={() => (
      <DropdownMenu closeOnClick>
        {controls.map((control) => (
          <DropdownItem
            key={control}
            onClick={() => onChange(control)}
            label={getControlLabel(control, translator).title}
            meta={getControlLabel(control, translator).description}
            styleType={control === activeControl ? "secondary" : "tertiary"}
            multiline
          />
        ))}
      </DropdownMenu>
    )}
  >
    <Button
      styleType="primary-alt"
      size="small"
      inverted={inverted}
      style={{ marginRight: 4 }}
      {...buttonProps}
    >
      {getControlLabel(activeControl, translator).title}
      <Pathicon icon="chevron-down" style={{ marginLeft: 2 }} />
    </Button>
  </DropdownTrigger>
)

CommunitAreaDropdown.displayName = "CommunitAreaDropdown"

// controlled component
const CommunityAreayFilter = ({
  children,
  filter,
  sort,
  filters,
  sorts,
  onFilter,
  onSort,
  getControlFilterLabel,
  getControlSortLabel,
  inverted,
  className,
  ...buttonProps
}) => {
  const { t, tc } = useTranslate()
  const screensize = useScreensizeContext()
  const alignment = screensize === "sm" ? "right" : "left"

  return (
    <StyledRow className={classnames("CommunityAreaFilter", className)}>
      <div>
        {!!sorts && (
          <span style={{ whiteSpace: "nowrap" }}>
            <CommunitAreaDropdown
              control={sort}
              controls={sorts}
              onChange={onSort}
              getControlLabel={getControlSortLabel}
              inverted={inverted}
              alignment="left"
              translator={t}
              {...buttonProps}
            />
          </span>
        )}

        <span style={{ whiteSpace: "nowrap" }}>
          <CommunitAreaDropdown
            control={filter}
            controls={filters}
            onChange={onFilter}
            getControlLabel={getControlFilterLabel}
            alignment={sorts ? alignment : "left"}
            inverted={inverted}
            translator={tc}
            {...buttonProps}
          />
        </span>
      </div>
      {children}
    </StyledRow>
  )
}

CommunityAreayFilter.displayName = "CommunityAreayFilter"

CommunityAreayFilter.propTypes = {
  filter: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sort: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  filters: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.string)
  ]),
  sorts: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.arrayOf(PropTypes.string)
  ]),
  onFilter: PropTypes.func,
  onSort: PropTypes.func,
  getControlFilterLabel: PropTypes.func,
  getControlSortLabel: PropTypes.func,
  inverted: PropTypes.bool
}

export default CommunityAreayFilter
